module.exports = __webpack_public_path__ + "958ac44bed3c8ed64dbdd0b28f349243.png";